













































































import { defineComponent, ref, PropType, computed, useRoute } from '@nuxtjs/composition-api';
import { useMediaQuery } from '@vueuse/core';
import ProductCartModalBody from '~/components/pages/Product/ProductCartModalBody.vue';
import AppModal from '~/components/partials/App/AppModal.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { useShipmentFreeMessage } from '~/composables/cart/useShipmentFreeMessage';
import { useKarteCartTag } from '~/composables/karte/useKarteCartTag';
import { useGoogleTag } from '~/composables/tag/useGoogleTag';
import { useMatchMedia } from '~/composables/useMatchMedia';
import { useStore } from '~/composables/useStore';
import { MERCHANT_ID } from '~/constants';
import { getSpecialPricePromotion } from '~/utils/modules/products';
import { CartSetProductVariant } from '~/types/modules/cart';
import { ProductShowECResponseSchema } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppRectButton,
    ProductCartModalBody,
    AppModal,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const { setKarteCartTag } = useKarteCartTag();
    const hasPurchased = ref(false);
    const isUpdatingCart = ref(false);
    const isTouchDevice = useMediaQuery('(hover: none)');
    const { isMobile } = useMatchMedia();
    const { setShippingAndPayment } = useShipmentFreeMessage();
    const { setGoogleCartTag } = useGoogleTag();

    const isNowOnSale = computed(() => props.ecResponse.product_variants.some((variant) => variant.now_on_sale_flag));
    const hasStock = computed(
      () => (props.ecResponse.product_variants.filter((variant) => variant.stock_count) || []).length > 0
    );

    const selectedTotal = computed(() =>
      store.state.product.detail.selectedFlexibleSetItems.reduce(
        (totalCount: number, currentItem) => totalCount + currentItem.quantity,
        0
      )
    );
    const totalLimit = computed(
      () => props.ecResponse.product_variants.find((productVariant) => productVariant.set_items)?.set_item_limit || 0
    );

    const addToSetItemCart = async () => {
      isUpdatingCart.value = true;
      const setItem: CartSetProductVariant = {
        product_variant_id: Number(
          props.ecResponse.product_variants?.find((productVariant) => productVariant.set_items)?.id
        ),
        quantity: 1,
        set_items: store.state.product.detail.selectedFlexibleSetItems.map((item) => ({
          product_variant_id: item.data.productVariantId,
          quantity: item.quantity,
        })),
      };
      // 購入処理
      try {
        await store.dispatch('modules/cart/updateCart', { setProducts: [setItem] });
        /**
         * カートイン後のモーダルに出すメッセージを取得する
         */
        await setShippingAndPayment(props.ecResponse.type);
        hasPurchased.value = true;
      } catch {
        // 何もしない
      } finally {
        isUpdatingCart.value = false;
      }

      // KARTE
      await setKarteCartTag();

      // スタッフスタート カート計測
      if (window.staffStart) {
        try {
          const skuCode = props.ecResponse.product_variants[0].enterprise_system_code;
          window.staffStart.cart.sendTrackingRequest(MERCHANT_ID, {
            product_code: skuCode,
            count: 1,
          });
        } catch {
          // 何もしない
        }
      }

      // collect_code
      try {
        if (window._etmc) {
          window._etmc.push(['trackPageView', { item: 'c_' + props.ecResponse.code || '' }]);
        }
      } catch {
        // 何もしない
      }

      /* GTMにタグ設置のイベントを発火 */
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'tlb_dmp_cart',
        tlb_dmp: { user_id: store.state.user.info.userBase?.uuid, item_id: setItem.product_variant_id },
      });

      if (!setItem.set_items) return;

      const { path } = route.value;

      const productVariant = props.ecResponse.product_variants?.find((productVariant) => productVariant.set_items);
      const specialPrice = getSpecialPricePromotion(productVariant?.price_settings);
      const taxIncludedPrice = specialPrice
        ? specialPrice.price_including_tax
        : productVariant?.price_settings?.price_including_tax;
      const taxExcludedPrice = specialPrice
        ? specialPrice.price_excluding_tax
        : productVariant?.price_settings?.price_excluding_tax;
      const { langs, categories } = props.ecResponse;

      /** eコマース用カートインイベントの発火 */
      setGoogleCartTag(
        taxExcludedPrice ?? 0,
        {
          item_name: langs.find(({ id }) => id === 'ja')?.name,
          item_id: props.ecResponse.code,
          price: taxIncludedPrice ?? 0,
          item_category: categories[0].name,
          item_list_name: path,
        },
        '商品一覧_カートイン'
      );
    };

    return {
      hasPurchased,
      isUpdatingCart,
      isTouchDevice,
      isNowOnSale,
      hasStock,
      selectedTotal,
      totalLimit,
      addToSetItemCart,
      isMobile,
    };
  },
});
